import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";
import AppShell from "@/components/AppShell";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ResetPassword from "@/pages/ResetPassword";
import ContactUs from "@/pages/ContactUs";
import Dashboard from "@/pages/Dashboard";
import Feed from "@/pages/Feed";
import Trending from "@/pages/Trending";
import AiAnalysis from "@/pages/AiAnalysis";
import Tenders from "@/pages/Tenders";
import Organisation from "@/pages/Organisation";
import Projects from "@/pages/Projects";
import ProjectFormPage from "@/pages/ProjectFormPage";
import ProjectDetail from "@/pages/ProjectDetail";
import Settings from "@/pages/Settings";
import Team from "@/pages/Team";
import AdminPanel from "@/pages/AdminPanel";
import ClientsOverview from "@/pages/ClientsOverview";
import ClientProjects from "@/pages/ClientProjects";
import CostMonitor from "@/pages/CostMonitor";
// PlatformSettings page hidden from the app (Phase 1) — route redirects to /app.
import Usage from "@/pages/Usage";
import WaitlistPage from "./pages/WaitlistPage";
import TermsConditions from "./pages/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import FAQs from "./pages/Faqs";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-[#64748B]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/app" element={<Protected><Dashboard /></Protected>} />
            <Route path="/app/feed" element={<Protected><Feed /></Protected>} />
            <Route path="/app/trending" element={<Protected><Trending /></Protected>} />
            <Route path="/app/ai-analysis" element={<Protected><AiAnalysis /></Protected>} />
            <Route path="/app/tenders" element={<Protected><Tenders /></Protected>} />
            <Route path="/app/organisation" element={<Protected><Organisation /></Protected>} />
            <Route path="/app/action-items" element={<Protected><Feed initialTab="actions" /></Protected>} />
            <Route path="/app/projects" element={<Protected><Projects /></Protected>} />
            <Route path="/app/projects/new" element={<Protected><ProjectFormPage /></Protected>} />
            <Route path="/app/projects/:id" element={<Protected><ProjectDetail /></Protected>} />
            <Route path="/app/team" element={<Protected><Team /></Protected>} />
            <Route path="/app/usage" element={<Protected><Usage /></Protected>} />
            <Route path="/app/settings" element={<Protected><Settings /></Protected>} />
            <Route path="/app/admin" element={<Protected><AdminPanel /></Protected>} />
            <Route path="/app/admin/clients" element={<Navigate to="/app/admin/client-projects" replace />} />
            <Route path="/app/admin/client-projects" element={<Protected><ClientProjects /></Protected>} />
            <Route path="/app/admin/cost-monitor" element={<Protected><CostMonitor /></Protected>} />
            <Route path="/app/admin/platform-settings" element={<Navigate to="/app" replace />} />
            <Route path="/app/admin/waitlist" element={<Protected><WaitlistPage /></Protected>} />

            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsConditions />} />
            <Route path="/faqs" element={<FAQs />} />


            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
